"use strict";

export function initInScope($scope) {
    let $skiplinks = $('.js-skip-links');
    $skiplinks.on('click', function () {
        let $target = $($(this).attr('data-href'));
        $target.attr('tabindex', '-1');
        $target.focus();

        if($target.attr('id') === 'main-nav') {
            window.scrollTo(window.scrollX, 0);
        } else {
            window.scrollTo(window.scrollX, $target[0].offsetTop);
        }

    });
}